document.addEventListener('DOMContentLoaded', () => {
  const siteHeader = document.querySelector('[data-site-header]');
  const headerGroup = siteHeader?.closest('.shopify-section-group-header-group, .shopify-section-header-group');
  if (siteHeader && headerGroup) {
    let scrollFrame;
    const syncHeaderState = () => {
      const condensed = window.scrollY > 72;
      siteHeader.classList.toggle('is-condensed', condensed);
      headerGroup.classList.toggle('is-condensed', condensed);
      scrollFrame = undefined;
    };

    syncHeaderState();
    window.addEventListener('scroll', () => {
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(syncHeaderState);
    }, { passive: true });
  }

  const bindMobileNavigation = (scope = document) => {
    const header = scope.querySelector?.('[data-site-header]') || document.querySelector('[data-site-header]');
    const toggle = header?.querySelector('.menu-toggle');
    const menu = header?.querySelector('.mobile-nav');
    if (!toggle || !menu || toggle.dataset.mobileNavBound === 'true') return;

    toggle.dataset.mobileNavBound = 'true';

    const setMenuOpen = (open, returnFocus = false) => {
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close navigation menu' : 'Open navigation menu');
      toggle.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', String(!open));
      menu.classList.toggle('is-open', open);
      document.documentElement.classList.toggle('mobile-menu-open', open);
      if (returnFocus) toggle.focus({ preventScroll: true });
    };

    toggle.addEventListener('click', () => {
      setMenuOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });

    menu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => setMenuOpen(false));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        setMenuOpen(false, true);
      }
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 1100 && toggle.getAttribute('aria-expanded') === 'true') {
        setMenuOpen(false);
      }
    }, { passive: true });
  };

  bindMobileNavigation();
  document.addEventListener('shopify:section:load', (event) => bindMobileNavigation(event.target));

  document.querySelectorAll('[data-hero-carousel]').forEach((carousel) => {
    const slides = [...carousel.querySelectorAll('[data-hero-slide]')];
    const previous = carousel.querySelector('[data-hero-prev]');
    const next = carousel.querySelector('[data-hero-next]');
    const current = carousel.querySelector('[data-hero-current]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let activeIndex = 0;
    let autoplayTimer;
    let userStopped = false;
    let touchStartX = 0;

    if (slides.length < 2 || !previous || !next || !current) return;

    const pause = () => {
      window.clearInterval(autoplayTimer);
      autoplayTimer = undefined;
    };

    const showSlide = (nextIndex, manual = false) => {
      activeIndex = (nextIndex + slides.length) % slides.length;
      if (manual) {
        userStopped = true;
        pause();
      }

      slides.forEach((slide, index) => {
        const active = index === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });

      current.textContent = String(activeIndex + 1).padStart(2, '0');
      carousel.style.setProperty('--hero-progress', `${((activeIndex + 1) / slides.length) * 100}%`);
    };

    const play = () => {
      if (userStopped || reducedMotion.matches || document.hidden || autoplayTimer) return;
      autoplayTimer = window.setInterval(() => showSlide(activeIndex + 1), 6500);
    };

    previous.addEventListener('click', () => showSlide(activeIndex - 1, true));
    next.addEventListener('click', () => showSlide(activeIndex + 1, true));
    carousel.addEventListener('mouseenter', pause);
    carousel.addEventListener('mouseleave', play);
    carousel.addEventListener('focusin', pause);
    carousel.addEventListener('focusout', play);
    carousel.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX || 0;
      pause();
    }, { passive: true });
    carousel.addEventListener('touchend', (event) => {
      const distance = (event.changedTouches[0]?.clientX || 0) - touchStartX;
      if (Math.abs(distance) >= 45) showSlide(activeIndex + (distance < 0 ? 1 : -1), true);
      else play();
    }, { passive: true });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) pause();
      else play();
    });
    reducedMotion.addEventListener('change', () => {
      pause();
      play();
    });

    showSlide(0);
    play();
  });

  const shopMenu = document.querySelector('[data-shop-menu]');
  const shopTrigger = document.querySelector('[data-shop-trigger]');
  if (shopMenu && shopTrigger) {
    let suppressFocusOpen = false;
    const setShopOpen = (open) => {
      shopMenu.classList.toggle('is-open', open);
      shopTrigger.setAttribute('aria-expanded', String(open));
    };

    shopMenu.addEventListener('mouseenter', () => setShopOpen(true));
    shopMenu.addEventListener('mouseleave', () => setShopOpen(false));
    shopMenu.addEventListener('focusin', () => {
      if (!suppressFocusOpen) setShopOpen(true);
    });
    shopMenu.addEventListener('focusout', () => {
      window.setTimeout(() => {
        if (!suppressFocusOpen) setShopOpen(shopMenu.contains(document.activeElement));
      }, 0);
    });
    shopMenu.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        suppressFocusOpen = true;
        setShopOpen(false);
        shopTrigger.focus();
        window.setTimeout(() => {
          suppressFocusOpen = false;
          setShopOpen(false);
        }, 0);
      }
    });
  }

  document.querySelectorAll('[data-shape-tabs]').forEach((root) => {
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const panels = [...root.querySelectorAll('[role="tabpanel"]')];
    tabs.forEach((tab, index) => tab.addEventListener('click', () => {
      tabs.forEach((item, i) => {
        const active = i === index;
        item.classList.toggle('is-selected', active);
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel, i) => panel.hidden = i !== index);
    }));
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const price = document.querySelector('[data-product-price]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
    });
  });
});
